import { Directive, OnInit } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { VirtualFolder } from '@modules/files/types/virtual-folder';
import { StateKey } from '@modules/settings/types/state-key';
import { FilesContextMenuComponent } from '../components/files-context-menu/files-context-menu.component';
import { DPContextMenuDirective } from './dp-context-menu.directive';

@Directive({
  selector: '[appDPFilesContextMenu]',
  standalone: false,
})
export class FilesContextMenuDirective
  extends DPContextMenuDirective<VirtualFolder, FilesContextMenuComponent>
  implements OnInit
{
  protected override readonly application = Application.files;
  protected override readonly stateKey = StateKey.filesDPSidebarFilters;

  registerComponent() {
    return FilesContextMenuComponent;
  }
}
